import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faClose, faCircleInfo } from '@fortawesome/free-solid-svg-icons';

import api from "@/helpers/fetch";

library.add(faClose, faCircleInfo);

@Component
export default class PopoverButton extends Vue {
	@Prop({ required: true, type: Number }) infoId!: number;

	status = '';
	desc = '';
	name = '';
	theme = '';
	trial = '';
	loading = false;

	togglePopover() {
		// @ts-ignore
		if (this.$refs.popover.show) {
		// @ts-ignore
			this.$refs.popover.$emit('open');
		} else {
		// @ts-ignore
			this.$refs.popover.$emit('close');
		}
	}

	getPopoverBtn() {
		// @ts-ignore
		return this.$refs.infoPopover;
	}

	async load() {
		this.loading = true;
		const res = await api.get('/api/calc/subjects/' + this.infoId);
		if (res.ok) {
			this.status = res.data.status;
			this.desc = res.data.desc;
			this.name = res.data.name;
			this.theme = res.data.theme;
			this.trial = res.data.trial;
		}
		this.loading = false;
	}

	get statusColor() {
		if (this.status === 'Repercussão Geral') return 'text-success';
		if (this.status === 'Repetitivo') return 'text-warning';
		return '';
	}

	mounted() {
		this.load();
	}
}